import React from 'react';
import { Achievement } from '../../data/go2LegendeMock';
import { Trophy, Lock, Plane, Users, SunSnow, Coins, Map, Globe, Heart, PartyPopper, Sun, Mountain, Flame, Grid3x3, type LucideProps } from 'lucide-react';

interface Props {
  achievements: Achievement[];
}

const IconMap: Record<string, React.FC<LucideProps>> = {
  'Plane': Plane,
  'Users': Users,
  'SunSnow': SunSnow,
  'Coins': Coins,
  'Map': Map,
  'Globe': Globe,
  'Heart': Heart,
  'PartyPopper': PartyPopper,
  'Sun': Sun,
  'Mountain': Mountain,
  'Flame': Flame,
  'Grid3x3': Grid3x3,
};

export const AchievementsList: React.FC<Props> = ({ achievements }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {achievements.map((achievement) => {
        const Icon = IconMap[achievement.icon] || Trophy;
        
        return (
          <div 
            key={achievement.id} 
            className={`rounded-xl p-6 border transition-all ${
              achievement.is_unlocked 
                ? 'bg-white border-yellow-200 shadow-sm' 
                : 'bg-gray-50 border-gray-200 opacity-75'
            }`}
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                achievement.is_unlocked ? 'bg-yellow-100 text-yellow-600' : 'bg-gray-200 text-gray-400'
              }`}>
                <Icon className="w-6 h-6" />
              </div>
              {achievement.is_unlocked ? (
                <span className="bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded-full">
                  Otključano
                </span>
              ) : (
                <Lock className="w-5 h-5 text-gray-400" />
              )}
            </div>
            
            <h3 className={`text-lg font-bold mb-2 ${achievement.is_unlocked ? 'text-go2-pink' : 'text-gray-500'}`}>
              {achievement.name}
            </h3>
            <p className="text-sm text-gray-600 mb-4 h-10">
              {achievement.description}
            </p>
            
            <div className="flex items-center text-sm font-medium">
              <span className={`${achievement.is_unlocked ? 'text-yellow-600' : 'text-gray-400'}`}>
                Nagrada: {achievement.reward_points} bodova
              </span>
              {achievement.unlocked_date && (
                <span className="ml-auto text-gray-400 text-xs">
                  {achievement.unlocked_date}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
